// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { format } from "date-fns";
// import { hi } from "date-fns/locale";
// import { Link, useNavigate } from "react-router-dom";
// import { Circles } from 'react-loader-spinner';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faClock } from "@fortawesome/free-solid-svg-icons";
// import DOMPurify from 'dompurify';
// // import './style1.css';


// const truncateText = (text, maxLength) => {
//   if (text.length > maxLength) {
//     return text.substring(0, maxLength);
//   }
//   return text;
// };

// const isDesktopScreen = () => window.innerWidth >= 1024;
// const truncateHtml = (html, maxLength) => {
//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;
//   const text = tempDiv.textContent || tempDiv.innerText || "";

//   if (text.length <= maxLength) return html;

//   let charCount = 0;
//   let isTruncated = false;

//   const traverse = (node) => {
//     let newNode;
//     if (node.nodeType === Node.TEXT_NODE) {
//       if (charCount >= maxLength) return document.createTextNode("");
//       const remaining = maxLength - charCount;
//       const truncated = node.textContent.slice(0, remaining);
//       charCount += truncated.length;
//       if (charCount >= maxLength && !isTruncated) {
//         isTruncated = true;
//         newNode = document.createTextNode(truncated + "..."); // append dots
//       } else {
//         newNode = document.createTextNode(truncated);
//       }
//     } else if (node.nodeType === Node.ELEMENT_NODE) {
//       newNode = node.cloneNode(false);
//       node.childNodes.forEach((child) => {
//         if (charCount < maxLength) {
//           newNode.appendChild(traverse(child));
//         }
//       });
//     }
//     return newNode;
//   };

//   const truncatedDiv = traverse(tempDiv);
//   return truncatedDiv.outerHTML;
// };


// const stripHtmlTags = (html, maxLength) => {
//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;
//   const strippedText = tempDiv.textContent || tempDiv.innerText || "";
//   return truncateText(strippedText, maxLength);
// };
// const renderHtmlContent = (html) => {
//   const sanitizedHtml = DOMPurify.sanitize(html);
//   return { __html: sanitizedHtml };
// };


// var local = "https://localhost:44351/api/home/lifestyle"
// var online = "https://api.shabdtoday.com/api/home/lifestyle"
// var clicklocal = "https://localhost:44351/api/home/update-viewcount"
// var clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

// export default function LifeStyle() {
//   const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [fetching, setFetching] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const observer = useRef();

//   const fetchNews = async () => {
//     if (!hasMore || fetching) return;

//     setFetching(true);
//     try {
//       const response = await axios.get(`${online}?page=${page}&limit=4`);

//       if (response.data && response.data.lifestyle.length > 0) {
//         setNews((prevNews) => {
//           const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
//           const newNews = response.data.lifestyle.filter((item) => !existingIds.has(item.mainKhabarId));
//           return [...prevNews, ...newNews];
//         });
//         setPage((prevPage) => prevPage + 1);
//       } else {
//         setHasMore(false);
//       }
//     } catch (error) {
//       console.error("Error fetching news:", error.message);
//     }
//     setFetching(false);
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchNews();
//   }, []);

//   useEffect(() => {
//     observer.current = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting) {
//         fetchNews();
//       }
//     });

//     const target = document.getElementById("load-more");
//     if (target) observer.current.observe(target);

//     return () => observer.current && observer.current.disconnect();
//   }, [news]);

//   const handleNewsClick2 = async (slug, mainKhabarId) => {
//     try {
//       const response = await axios.post(`${clickonline}`, {
//         mainKhabarId: mainKhabarId
//       });

//       if (response.status === 200) {
//         console.log("View count updated successfully", response.data);
//         window.location.href =`/News-Details/${slug}`;
//       } else {
//         console.error("Failed to update view count", response.data);
//       }
//     } catch (error) {
//       console.error("Error updating view count:", error.response ? error.response.data : error.message);
//     }
//   };

//   const formatDateInHindi = (dateString) => {
//     const date = new Date(dateString);
//     const monthsInHindi = [
//       "जनवरी",
//       "फरवरी",
//       "मार्च",
//       "अप्रैल",
//       "मई",
//       "जून",
//       "जुलाई",
//       "अगस्त",
//       "सितंबर",
//       "अक्टूबर",
//       "नवंबर",
//       "दिसंबर",
//     ];
//     const seconds = date.getSeconds();
//     const minute = date.getMinutes();
//     var hour = date.getHours();
//     const day = date.getDate();
//     const month = monthsInHindi[date.getMonth()];
//     const year = date.getFullYear();
//     const amPm = hour >= 12 ? "PM" : "AM";
//     hour = hour % 12 || 12;
//     return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
//   };
//   const getTimeAgoInHindi = (dateString) => {
//     const now = new Date();
//     const past = new Date(dateString);
//     const diffInSeconds = Math.floor((now - past) / 1000);

//     if (diffInSeconds < 60) {
//       return `${diffInSeconds} सेकंड पहले`;
//     }

//     const diffInMinutes = Math.floor(diffInSeconds / 60);
//     if (diffInMinutes < 60) {
//       return `${diffInMinutes} मिनट पहले`;
//     }

//     const diffInHours = Math.floor(diffInMinutes / 60);
//     if (diffInHours < 24) {
//       return `${diffInHours} घंटे पहले`;
//     }

//     const diffInDays = Math.floor(diffInHours / 24);
//     if (diffInDays < 30) {
//       return `${diffInDays} दिन पहले`;
//     }

//     const diffInMonths = Math.floor(diffInDays / 30);
//     if (diffInMonths < 12) {
//       return `${diffInMonths} महीने पहले`;
//     }

//     const diffInYears = Math.floor(diffInMonths / 12);
//     return `${diffInYears} साल पहले`;
//   };

//   const generateShareLinks = (mainKhabarId, newsTag) => {
//     const encodednewsTag = encodeURIComponent(newsTag);
//     const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
//     return {
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
//       whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
//       twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
//       instagram: `https://www.instagram.com/`
//     };
//   };

//   if (loading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         {/* <Circles
//           height="30"
//           width="30"
//           color="#f7265c"
//           ariaLabel="circles-loading"
//           wrapperStyle={{}}
//           wrapperClass=""
//           visible={true}
//         /> */}
//       </div>
//     );
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }
//   const baseUrl = "https://api.shabdtoday.com/";
//   const image_resize = "https://api.shabdtoday.com/api/home/resize";


//   return (
//     <div>
//       <div className="row vc_row">
//         <div className="ak_vc_container">
//           <div className="wpb_column ak_column_3 vc_column_container">
//             <div className="ak_vc_wrapper wpb_wrapper">
//               <div
//                 className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
//                 id="block_65f7f61f36732_2"
//               >
//                 <div className="ak-block-inner clearfix">
//                   <div className="ak-block-posts clearfix">
//                     {news.map((post) => {
//                       const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
//                       const htmlContent = isDesktop
//                         ? truncateHtml(post.newsTag, 100)
//                         : post.newsTag;
//                       return (

//                         <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news mt-4" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
//                           <div className="ak-module-inner clearfix">
//                             <div className="ak-module-featured">

//                               <div className="ak-module-details">
//                                 <h1 className="ak-module-title">
//                                   <Link
//                                     to="#"
//                                     onClick={(e) => {
//                                       e.preventDefault(); // Prevent default navigation
//                                       handleNewsClick2(post.slug, post.mainKhabarId);
//                                     }}
//                                     rel="bookmark"
//                                     aria-label="Shabd Today"
//                                     title={stripHtmlTags(post.newsTag)}
//                                   >
//                                     <span
//                                       className="responsive-font"
//                                       style={{ lineHeight: "30px" }}
//                                       dangerouslySetInnerHTML={{ __html: htmlContent }}
//                                     />
//                                     &nbsp;
//                                   </Link>
//                                 </h1>
//                               </div>
//                               <div className="ak-featured-cover">
//                                 <Link
//                                   to="#"
//                                   onClick={(e) => {
//                                     e.preventDefault();
//                                     handleNewsClick2(post.slug, post.mainKhabarId);
//                                   }}
//                                   className="ak-featured-link"
//                                   rel="bookmark"
//                                   aria-label="Shabd Today"
//                                   title={stripHtmlTags(post.newsTag, 150)}
//                                 >

//                                   <div className="ak-featured-thumb size-500">
//                                     <img
//                                       src={`${image_resize}?url=${baseUrl}${post.newsImage}&w=245&h=123&outtype=webp`}
//                                       alt={stripHtmlTags(post.newsTag, 150)}
//                                       width={410}
//                                       height={300}
//                                       // loading="lazy"
//                                     />
//                                   </div>

//                                   {/* <div className="ak-featured-thumb  size-500">
//                                     <img
//                                       fetchpriority="high"
//                                       decoding="async"
//                                       width={410}
//                                       height={300}
//                                       loading="lazy"
//                                       src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
//                                       alt={stripHtmlTags(post.newsTag, 150)}
//                                       data-src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       data-sizes="auto"
//                                       data-srcset={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       data-expand={700}
//                                     />
//                                   </div> */}
//                                 </Link>
//                               </div>
//                               <div className="ak-module-terms badge">
//                               </div>
//                             </div>


//                           </div>

//                         </article>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
//         {fetching && <p>Loading more news...</p>}
//         {!hasMore && <p>No more news available.</p>}
//       </div> */}
//     </div>
//   );
// }

import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { Helmet } from "react-helmet";

// ✅ Utility functions
const truncateText = (text, maxLength) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const isDesktopScreen = () => window.innerWidth >= 1024;

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "...");
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};

// ✅ Updated API endpoints
const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";
const online = "https://api.shabdtoday.com/api/home/tajaKhabars";
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount";

export default function LifeStyle() {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  // ✅ Fetch ताज़ा खबरें
  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=4`);
      const data = response.data?.tazaKhabars || [];

      if (data.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = data.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching TazaKhabars:", error.message);
      setError("समाचार लोड करने में समस्या हुई।");
    } finally {
      setFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  // ✅ Update view count + redirect
  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(clickonline, { mainKhabarId });
      if (response.status === 200) {
        window.location.href = `/News-Details/${slug}`;
      }
    } catch (error) {
      console.error("Error updating view count:", error.message);
    }
  };

  // ✅ Format dates in Hindi
  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून",
      "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"
    ];
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";
    return `${day} ${month} ${year}, ${hours % 12 || 12}:${minutes} ${amPm}`;
  };

  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);
    if (diffInSeconds < 60) return `${diffInSeconds} सेकंड पहले`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes} मिनट पहले`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} घंटे पहले`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return `${diffInDays} दिन पहले`;
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `${diffInMonths} महीने पहले`;
    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
      instagram: `https://www.instagram.com/`,
    };
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <Helmet>
        <title>लाइफ़स्टाइल न्यूज़ – सेहत, फैशन, रिलेशनशिप और लाइफ़टिप्स | ShabdToday</title>

        <meta name="title" content="आज की लेटेस्ट लाइफस्टाइल न्यूज़ हिंदी में – सेलिब्रिटी फैशन, ब्यूटी और स्किनकेयर की ताज़ा अपडेट!" />
        <meta
          name="description"
          content="देश–दुनिया की लेटेस्ट लाइफस्टाइल न्यूज़ हिंदी में पढ़ें — सेलिब्रिटी फैशन ट्रेंड्स, महिलाओं के लिए ब्यूटी टिप्स, स्किनकेयर अपडेट और ग्लैमर जगत की हर बड़ी खबर, सबसे पहले और सबसे सटीक।" />
        <meta
          name="keywords"
          content="लाइफस्टाइल न्यूज़ हिंदी, फैशन न्यूज़ हिंदी, ब्यूटी टिप्स हिंदी, स्किनकेयर न्यूज़, सेलिब्रिटी लाइफस्टाइल, महिलाओं के लिए ब्यूटी सलाह, आज की लाइफस्टाइल खबरें, बॉलीवुड फैशन अपडेट, हिंदी लाइफस्टाइल ट्रेंड्स, Hindi Lifestyle News" />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />

        <link rel="canonical" href="https://shabdtoday.com/LifeStyle-News" />

        <meta property="og:title" content="लाइफ़स्टाइल न्यूज़ – स्वास्थ्य और फैशन अपडेट | ShabdToday" />
        <meta
          property="og:description"
          content="लाइफ़स्टाइल की प्रमुख खबरें—स्वास्थ्य, फैशन, फिटनेस, रिलेशनशिप और ब्यूटी टिप्स हिंदी में पढ़ें।"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/LifeStyle-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "लाइफ़स्टाइल – ShabdToday",
            "url": "https://shabdtoday.com/LifeStyle-News",
            "description": "स्वास्थ्य, फैशन, फिटनेस और रिलेशनशिप से जुड़े नवीनतम टिप्स और खबरें।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script>

      </Helmet>
      <div>
        <h1 className='head' style={{ color: 'crimson', marginLeft: 10,marginTop:10 }}>
          लाइफ़स्टाइल (लाइफ़स्टाइल की ताज़ा खबरें)
        </h1>
      </div>
      {/* <h1 className="visually-hidden">लाइफ़स्टाइल की ताज़ा खबरें</h1>
      <h2 className="visually-hidden">स्वास्थ्य | फैशन | रिलेशनशिप</h2>
      <h3 className="visually-hidden">फिटनेस | ब्यूटी | घरेलू टिप्स</h3> */}
      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;
                      return (
                        <article
                          key={post.mainKhabarId}
                          className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix mt-4"
                          style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}
                        >
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-module-details">
                                <h2 className="ak-module-title">
                                  <Link
                                    to={`/News-Details/${post.slug}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    }}
                                    title={stripHtmlTags(post.newsTag)}
                                  >
                                    <span
                                      className="responsive-font"
                                      style={{ lineHeight: "30px" }}
                                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                                    />
                                  </Link>
                                </h2>
                              </div>
                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  title={stripHtmlTags(post.newsTag, 150)}
                                >
                                  <div className="ak-featured-thumb size-500">
                                    <img
                                      src={baseUrl + post.newsImage}
                                      alt={stripHtmlTags(post.slug, 150)}
                                      width={600}
                                      height={300}
                                    />
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );
}
